// standard
export const STANDARD = 'STANDARD';

// system
export const SYSTEM = 'SYSTEM';
